(()=>{
  if(customElements.get('juma-black-friday'))return;
  customElements.define('juma-black-friday',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();const {signal}=this.controller;
      this.start=Date.parse(this.dataset.start);this.end=Date.parse(this.dataset.end);
      this.key='juma-black-friday-2026-dismissed';this.dismissed=false;
      this.base=Date.now();this.monotonic=performance.now();
      this.parts=['days','hours','minutes','seconds'].map(name=>this.querySelector(`[data-${name}]`));
      try{this.dismissed=sessionStorage.getItem(this.key)==='1';}catch{}
      this.tick=()=>{
        clearTimeout(this.timer);if(!this.isConnected)return;
        const now=this.base+performance.now()-this.monotonic;
        const state=now<this.start?'upcoming':now<this.end?'active':'ended';
        this.hidden=this.dismissed||state==='ended';this.dataset.state=state;
        this.querySelector('[data-upcoming]').hidden=state!=='upcoming';
        this.querySelector('[data-active]').hidden=state!=='active';
        if(state==='upcoming'){
          let remaining=Math.max(0,Math.ceil((this.start-now)/1000));
          const values=[Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60];
          this.parts.forEach((el,i)=>{const value=String(values[i]).padStart(2,'0');if(el.textContent!==value)el.textContent=value;});
        }
        if(!document.hidden&&!this.hidden)this.timer=setTimeout(this.tick,Math.max(50,1000-now%1000));
      };
      this.querySelector('[data-close]').addEventListener('click',()=>{
        this.dismissed=true;try{sessionStorage.setItem(this.key,'1');}catch{}this.tick();
      },{signal});
      this.querySelector('[data-copy]').addEventListener('click',async()=>{
        const button=this.querySelector('[data-copy]'),feedback=this.querySelector('[data-feedback]');
        try{
          await navigator.clipboard.writeText(this.dataset.code);
          if(!this.isConnected)return;button.textContent=this.dataset.copiedLabel;feedback.textContent=this.dataset.copiedLabel;
          clearTimeout(this.copyTimer);this.copyTimer=setTimeout(()=>{button.textContent=this.dataset.copyLabel;},2500);
        }catch{feedback.textContent=this.dataset.copyError;}
      },{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)clearTimeout(this.timer);else this.tick();},{signal});
      addEventListener('pageshow',this.tick,{signal});
      this.tick();
      if(!this.dismissed){
        const began=performance.now();
        fetch(this.dataset.clockUrl,{method:'HEAD',cache:'no-store',credentials:'same-origin',signal}).then(response=>{
          const server=Date.parse(response.headers.get('date'));
          if(Number.isFinite(server)&&!signal.aborted){this.base=server+(performance.now()-began)/2;this.monotonic=performance.now();this.tick();}
        }).catch(()=>{});
      }
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;clearTimeout(this.timer);clearTimeout(this.copyTimer);}
  });
})();
